// Short public pages for town searches. Not linked from the homepage.
// Nearby towns match the lists already used on the longer area pages.

const shared = {
  how: 'Posting a job is free. Describe what needs collecting and where it is. Carriers in the area can send a price. You pick one, or you pick none. Posting does not book a van, and it does not mean anyone will send a price.',
  pay: 'On a priced job you pay by card after the job is marked complete. There is no customer fee.',
  scrap: 'Scrap collection is free to post. A scrap collector collects it.',
  carriers: 'Carriers are checked against the public register before approval.',
};

export const TOWN_LANDINGS = [
  {
    slug: 'swansea',
    name: 'Swansea',
    path: '/rubbish-removal-swansea',
    title: 'Rubbish and scrap removal in Swansea | The WasteGame',
    description:
      'Post a rubbish or scrap collection job in Swansea for free. Carriers in the area can send a price. You pick one, or none. Nearby places include Neath, Llanelli and Gorseinon.',
    h1: 'Rubbish removal in Swansea',
    purpose: 'This page is for people in Swansea who want rubbish or scrap collected.',
    nearby: 'Nearby places include Neath, Llanelli, Gorseinon and Pontardawe.',
    ...shared,
  },
  {
    slug: 'neath',
    name: 'Neath',
    path: '/rubbish-removal-neath',
    title: 'Rubbish and scrap removal in Neath | The WasteGame',
    description:
      'Post a rubbish or scrap collection job in Neath for free. Carriers in the area can send a price. You pick one, or none. Nearby places include Swansea and Port Talbot.',
    h1: 'Rubbish removal in Neath',
    purpose: 'This page is for people in Neath who want rubbish or scrap collected.',
    nearby: 'Nearby places include Swansea and Port Talbot.',
    ...shared,
  },
  {
    slug: 'port-talbot',
    name: 'Port Talbot',
    path: '/rubbish-removal-port-talbot',
    title: 'Rubbish and scrap removal in Port Talbot | The WasteGame',
    description:
      'Post a rubbish or scrap collection job in Port Talbot for free. Carriers in the area can send a price. You pick one, or none. Nearby places include Neath, Maesteg and Bridgend.',
    h1: 'Rubbish removal in Port Talbot',
    purpose: 'This page is for people in Port Talbot who want rubbish or scrap collected.',
    nearby: 'Nearby places include Neath, Maesteg and Bridgend.',
    ...shared,
  },
  {
    slug: 'llanelli',
    name: 'Llanelli',
    path: '/rubbish-removal-llanelli',
    title: 'Rubbish and scrap removal in Llanelli | The WasteGame',
    description:
      'Post a rubbish or scrap collection job in Llanelli for free. Carriers in the area can send a price. You pick one, or none. Nearby places include Swansea, Carmarthen and Ammanford.',
    h1: 'Rubbish removal in Llanelli',
    purpose: 'This page is for people in Llanelli who want rubbish or scrap collected.',
    nearby: 'Nearby places include Swansea, Carmarthen and Ammanford.',
    ...shared,
  },
  {
    slug: 'bridgend',
    name: 'Bridgend',
    path: '/rubbish-removal-bridgend',
    title: 'Rubbish and scrap removal in Bridgend | The WasteGame',
    description:
      'Post a rubbish or scrap collection job in Bridgend for free. Carriers in the area can send a price. You pick one, or none. Nearby places include Maesteg, Port Talbot and Cardiff.',
    h1: 'Rubbish removal in Bridgend',
    purpose: 'This page is for people in Bridgend who want rubbish or scrap collected.',
    nearby: 'Nearby places include Maesteg, Port Talbot and Cardiff.',
    ...shared,
  },
];

export function townLandingByPath(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return TOWN_LANDINGS.find((town) => town.path === path) || null;
}
